import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import DownloadReportsBlock from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DownloadReportsBlock));
